import { NgModule } from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { UiUtilsModule } from '../ui-utils/ui-utils.module';
import { AvailableTrafficPacksComponent } from './components/available-traffic-packs/available-traffic-packs.component';
import { AssistPaymentFormComponent } from './components/assist-payment-form/assist-payment-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { DialogService, DynamicDialog } from 'primeng/dynamicdialog';
import { SupportRequestComponent } from './components/support-request/support-request.component';
import { MessageDialogComponent } from './components/message-dialog/message-dialog.component';
import {ActivePacksComponent} from './components/active-packs/active-packs.component';
import {PersistanceService} from '../services/persistance.service';
import {DateTransformPipe} from './pipes/date-transform.pipe';
import {FocusDirective} from './directive/focus.directive';
import {LoadingComponent} from './components/loading/loading.component';
import { SourceModalComponent } from './components/source-modal/source-modal.component';
import {StatisticService} from './services/statistic.service';
import { SlidePanelComponent } from './components/slide-panel/slide-panel.component';
import {DialogModule} from 'primeng/dialog';
import {AnnouncementComponent} from './components/advertisement/announcement.component';
import {NotFoundComponent} from './components/not-found/not-found.component';
import {Button, ButtonDirective} from "primeng/button";
import {UiCardComponent} from "../ui-utils/components/ui-card/ui-card.component";
import {NavigationComponent} from "./components/navigation/navigation.component";
import {AccountComponent} from "./components/account/account.component";
import {Badge} from "primeng/badge";
import {Carousel} from "primeng/carousel";
import {Panel} from "primeng/panel";
import {TableModule} from "primeng/table";
import {Select} from "primeng/select";
import {DatePicker} from "primeng/datepicker";
import {NewsWidgetComponent} from "../news-widget/news-widget.component";


@NgModule({
  declarations: [
    DashboardComponent,
    AvailableTrafficPacksComponent,
    AssistPaymentFormComponent,
    ChangePasswordComponent,
    SupportRequestComponent,
    MessageDialogComponent,
    ActivePacksComponent,
    // TrafficDetailsComponent,
    DateTransformPipe,
    LoadingComponent,
    FocusDirective,
    SourceModalComponent,
    // TrafficDetailsTableComponent,
    SlidePanelComponent,
    AnnouncementComponent,
    NotFoundComponent,
    // StatisticBreadcrumbsComponent,
    // StatisticComponent,
  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    UiUtilsModule,
    ReactiveFormsModule,
    FormsModule,
    AngularSvgIconModule,
    ToastModule,
    DynamicDialog,
    DialogModule,
    ButtonDirective,
    Button,
    UiCardComponent,
    NavigationComponent,
    AccountComponent,
    Badge,
    Carousel,
    Panel,
    TableModule,
    Select,
    DatePicker,
    NewsWidgetComponent,
  ],
  exports: [
    AnnouncementComponent,
    LoadingComponent
  ],
  providers: [
    MessageService,
		DialogService,
    PersistanceService,
    DatePipe,
    DateTransformPipe,
    StatisticService
  ]
})
export class DashboardModule { }
